// extracted by mini-css-extract-plugin
module.exports = {"highlight":"MetadataForm_highlight__7B93-","bottom":"MetadataForm_bottom__2L1Kp"};